import '@angular/compiler';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';

import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';
import { loadingInterceptor } from './app/core/interceptors/loading.interceptor';
import { errorInterceptor } from './app/core/interceptors/error.interceptor';
import { retryInterceptor } from './app/core/interceptors/retry.interceptor';

// 👇 IMPORTAR MATSNACKBAR MODULE
import { importProvidersFrom, LOCALE_ID } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { routes } from './app/app.routes';
import { registerLocaleData } from '@angular/common';
import localeEsCl from '@angular/common/locales/es-CL';
import { NgxEchartsModule } from 'ngx-echarts';

registerLocaleData(localeEsCl, 'es-CL');

bootstrapApplication(AppComponent, {
  providers: [
    { provide: LOCALE_ID, useValue: 'es-CL' },
    provideRouter(routes),
    provideAnimations(),

    provideHttpClient(
      withInterceptors([
        retryInterceptor,      // 1️⃣ Primero: reintentar peticiones fallidas
        authInterceptor,       // 2️⃣ Segundo: añadir token de autenticación
        loadingInterceptor,    // 3️⃣ Tercero: mostrar loading
        errorInterceptor       // 4️⃣ Último: capturar y manejar errores
      ])
    ),

    importProvidersFrom(MatSnackBarModule), // 👈 SOLO ESTO
    importProvidersFrom(NgxEchartsModule.forRoot({ echarts: () => import('echarts') }))
  ]
});
